import { LanguageMapping } from '../stores/localization/language.data';

export enum SPECIAL_NATIVE_LANGUAGE {
  MULTIPLE_LANGUAGES = 'MULTIPLE_LANGUAGES',
  UNDETERMINED_LANGUAGE = 'UNDETERMINED_LANGUAGE',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  UNRECOGNIZED_LANGUAGE = 'UNRECOGNIZED_LANGUAGE',
  SPECIAL_VERSION = 'SPECIAL_VERSION',
  OFF_LANGUAGE = 'OFF_LANGUAGE',
  ADS = 'ADS',
}

export interface NativeNameByCode {
  code: string;
  nativeName?: string;
  specialNativeLanguage?: SPECIAL_NATIVE_LANGUAGE;
}

/**
 *  Get base local. Example en-uk => en
 * @param lang
 */
const getBaseLocal = (lang: string): string => {
  const splitAt = lang.indexOf('-');
  let major;

  if (splitAt >= 0) {
    major = lang.substring(0, splitAt);
  } else {
    major = lang;
  }

  major = major.toLowerCase();

  return major;
};

/**
 * Returns NativeNameByCode
 * if specialNativeLanguage is set, need to use PoEditor
 * @param code: string
 */
export const languageNativeNameByCode = (code: string): NativeNameByCode => {
  switch (code) {
    case 'mul':
      return { code, specialNativeLanguage: SPECIAL_NATIVE_LANGUAGE.MULTIPLE_LANGUAGES };
    case 'und':
      return { code, specialNativeLanguage: SPECIAL_NATIVE_LANGUAGE.UNDETERMINED_LANGUAGE };
    case 'zxx':
      return { code, specialNativeLanguage: SPECIAL_NATIVE_LANGUAGE.NOT_APPLICABLE };
    case 'off':
      return { code, specialNativeLanguage: SPECIAL_NATIVE_LANGUAGE.OFF_LANGUAGE };
    case 'ads':
      return { code, specialNativeLanguage: SPECIAL_NATIVE_LANGUAGE.ADS };
  }

  const language = getBaseLocal(code);

  if (code in LanguageMapping) {
    // @ts-expect-error TODO Fix
    return { code, nativeName: LanguageMapping[code]['settingsNativeName'] || LanguageMapping[code]['nativeName'] };
  } else if (language in LanguageMapping) {
    return {
      code,
      // @ts-expect-error TODO Fix
      nativeName: LanguageMapping[language]['settingsNativeName'] || LanguageMapping[language]['nativeName'],
      specialNativeLanguage: SPECIAL_NATIVE_LANGUAGE.SPECIAL_VERSION,
    };
  }

  return { code, specialNativeLanguage: SPECIAL_NATIVE_LANGUAGE.UNRECOGNIZED_LANGUAGE };
};
